<template>
    <div class="about-content">
        <div class="content-item" v-for="(item, index) in list" :key="index">
            <img :class="`content-img${item.type}`" :src="item.img">
            <p class="content-mes">{{item.des}}</p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        }
    }
}
</script>
<style lang="scss" scoped>
.about-content{
    width: 100%;
    padding: 0px 20px;
    .content-item{
        background:rgba(255,255,255,1);
        box-shadow:0px 5px 12px 0px rgba(147,147,147,0.14);
        border-radius:6px;
        padding: 20px;
        margin-bottom: 20px;
        .content-img{
            width: 100%;
        }
        .content-img1{
            width: 140px;
            margin: 0 auto
        }
        .content-mes{
            margin-top: 10px;
            font-size:12px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:#282828;
            line-height:22px;
            text-align: left;
        }
        &:last-of-type{
            margin-bottom: 0px;
        }
    }
} 
</style>